// ATTN: maintain alphabetical order
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import CommunicatorStore from 'customer-data-communicator/data/communicator/stores/CommunicatorStore';
import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import { getIsSampleContact } from 'crm_ui/utils/SampleContactUtils';
import { getHrefForLinkType, HubSpotAppLinkHandlerProvider, HUBSPOT_APP_LINK_TYPES } from 'crm-links/common/context/HubSpotAppLinkHandlerContext';
import { isSupportedNonRecordPageObjectType } from 'crm-links/record/utils';
import { getProperty, getId } from 'customer-data-objects/model/ImmutableModel';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import * as LoadingStatus from 'crm_data/flux/LoadingStatus';
// ATTN: maintain alphabetical order
import PortalIdParser from 'PortalIdParser';
import { ProfileMounted } from 'crm-fe-perf/timing/marks/crm-records-ui/performanceMarks';
import ProfileNotFound from './ProfileNotFound';
import ProfileThreeColumn from './common/components/ProfileThreeColumn';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { SampleContactContext } from 'crm-events-data/internal/sampleEvents/context/SampleContactContext';
// @ts-expect-error js module
import SharedDragDropContext from 'customer-data-ui-utilities/dnd/SharedDragDropContext';
// @ts-expect-error js module
import WithClassWrapper from 'customer-data-objects-ui-components/hoc/WithClassWrapper';
import useMarkOnMount from 'crm-fe-perf/timing/hooks/useMarkOnMount';
import { useCommunicatorState } from './hooks/useCommunicatorState';
import { useSetRecordPageTitle } from './hooks/useSetRecordPageTitle';
import { useHistory } from 'react-router-dom';
import CardLocationMiddlepane from '../../middlePane/CardLocationMiddlepane';
import useDefaultInteraction from 'crm-activity-creator-interactions-legacy/activityCreator/useDefaultInteraction';
import RecordsErrorBoundary from '../../errors/RecordsErrorBoundary';
import CrmContentError from '../error/CrmContentError';
import { useFetchObjectTypeCrmRecordsPageFAS } from './hooks/useFetchObjectTypeCrmRecordsPageFAS';
import { useIsSupportedRecordPage } from './hooks/useIsSupportedRecordPage';
import ProfilePopUpsContainer from './ProfilePopUpsContainer';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import useUpdateUrl from '../../activityCreator/useUpdateUrl';
import CopilotSetup from '../../copilot/CopilotSetup';
import { useSubjectDependency } from '../../hooks/useSubjectDependency';
import { ScrollTracker } from './ScrollTracker';
import { getObjectTypeIdForMetrics } from '../../utils/Metrics';
import { CrmLogger } from 'customer-data-tracking/loggers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// ATTN: maintain alphabetical order

export const communicatorDeps = {
  activeInteraction: {
    stores: [CommunicatorStore],
    deref() {
      return CommunicatorStore.get('interaction');
    }
  }
};
const isMergedRecord = ({
  subject,
  objectType,
  subjectId
}) => {
  if (LoadingStatus.isLoading(subject)) {
    return false;
  }
  if (objectType === CONTACT) {
    return `${subject.get('canonical-vid')}` !== subjectId;
  }
  return `${getId(subject)}` !== subjectId;
};
let isFirstLoad = true;
const Profile = ({
  query,
  objectType,
  subjectId
}) => {
  const objectTypeId = normalizeTypeId(objectType);
  const profileMountedDimensions = useMemo(() => {
    return {
      is_first_load: String(isFirstLoad),
      object_type_id: getObjectTypeIdForMetrics(objectTypeId)
    };
    // memoize the dimensions to avoid re-marking, we only want to mark on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useMarkOnMount(ProfileMounted, profileMountedDimensions);
  isFirstLoad = false;
  const history = useHistory();
  const {
    data,
    error
  } = useFetchObjectTypeCrmRecordsPageFAS(objectType);
  const isSupportedRecordPage = useIsSupportedRecordPage(normalizeTypeId(objectType), error, data);
  const activeInteraction = useStoreDependency(communicatorDeps.activeInteraction);
  const subject = useSubjectDependency(objectType, subjectId);
  const isSampleContact = getIsSampleContact(getProperty(subject, 'email'));
  useSetRecordPageTitle({
    objectType,
    subjectId
  });
  useDefaultInteraction({
    queryInteraction: query.interaction,
    isSampleContact,
    // @ts-expect-error objectType is typed to a limited set of string values
    objectType,
    subjectId,
    taskId: query.taskId,
    initialEmailSubject: query.initialEmailSubject,
    initialEmailBody: query.initialEmailBody
  });
  const {
    handleCardCommunicatorClick
  } = useCommunicatorState({
    objectType,
    subjectId,
    activeInteraction
  });

  // hook for managing url updates upon open/close AC window
  useUpdateUrl();
  const isInvalidProfile = useMemo(() => LoadingStatus.isEmpty(subject) ||
  // don't load record pages where subjectId doesn't match the ID of the fetched
  // subject we don't support this and want to redirect which is handled by
  // ProfileNotFound, this should only happen in the case of an object that
  // has been merged
  isMergedRecord({
    subject,
    objectType,
    subjectId
  }) || objectType === CONTACT && subject && !subject.get('is-contact'), [subject, subjectId, objectType]);
  const appLinkHandlers = useMemo(() => ({
    [HUBSPOT_APP_LINK_TYPES.ENGAGEMENT]: {
      onClick: (linkProps, event) => {
        event.preventDefault();
        history.push(`/record/${linkProps.objectTypeId}/${linkProps.objectId}?engagement=${linkProps.engagementId}`);
      }
    },
    [HUBSPOT_APP_LINK_TYPES.CARD_SETTINGS]: {
      getHref: linkProps => {
        // TODO: it would be ideal if we captured current query params here for the settings backlink
        // but the settings app doesn't currently support adding query params to the eschref
        const currentPath = `/contacts/${PortalIdParser.get()}${history.location.pathname}`;
        return getHrefForLinkType(HUBSPOT_APP_LINK_TYPES.CARD_SETTINGS, linkProps, {
          eschref: encodeURIComponent(currentPath)
        });
      }
    },
    [HUBSPOT_APP_LINK_TYPES.CRM_OBJECT_RECORD]: {
      onClick: (linkProps, event) => {
        // Do not prevent default if user is cmd/ctrl clicking to open in new tab
        if (!event.metaKey && !event.ctrlKey && !isSupportedNonRecordPageObjectType(linkProps.objectTypeId)) {
          event.preventDefault();
          history.push(`/record/${linkProps.objectTypeId}/${linkProps.objectId}`);
        }
      }
    },
    [HUBSPOT_APP_LINK_TYPES.LOCATION_SETTINGS]: {
      onClick: linkProps => {
        CrmLogger.log('recordInteractions', {
          action: 'customize record link clicked',
          fromObjectTypeId: linkProps.objectTypeId
        });
      }
    }
  }), [history]);
  if (isInvalidProfile || !isSupportedRecordPage) {
    return /*#__PURE__*/_jsx(ProfileNotFound, {
      objectType: objectType,
      objectId: subjectId
    });
  }
  const key = objectType + subjectId + (query && query._t || '');
  return /*#__PURE__*/_jsx(CopilotSetup, {
    children: /*#__PURE__*/_jsx(SampleContactContext.Provider, {
      value: isSampleContact,
      children: /*#__PURE__*/_jsxs(HubSpotAppLinkHandlerProvider, {
        value: appLinkHandlers,
        children: [/*#__PURE__*/_jsx(ProfilePopUpsContainer
        // @ts-expect-error too many arguments
        , {
          onCommunicatorClick: handleCardCommunicatorClick,
          objectType: objectType,
          subjectId: subjectId,
          query: query
        }), /*#__PURE__*/_jsx(ScrollTracker, {}), /*#__PURE__*/_jsx(ProfileThreeColumn, {
          objectType: objectType,
          onCommunicatorClick: handleCardCommunicatorClick,
          subject: subject,
          subjectId: subjectId,
          children: /*#__PURE__*/_jsx(RecordsErrorBoundary, {
            boundaryName: "CardLocationMiddlepane",
            ErrorComponent: CrmContentError,
            children: /*#__PURE__*/_jsx(CardLocationMiddlepane, {})
          })
        }, key)]
      })
    })
  });
};
Profile.displayName = 'Profile';
Profile.propTypes = {
  query: PropTypes.shape({
    interaction: PropTypes.string,
    forceLegacy: PropTypes.string,
    _t: PropTypes.string,
    taskId: PropTypes.string,
    csOpen: PropTypes.string,
    initialEmailSubject: PropTypes.string,
    initialEmailBody: PropTypes.string,
    approvalOpen: PropTypes.string
  }).isRequired
};

/*
If two instances of react-dnd's HTML5 backend are
initialized on the same page, a fatal error ("Cannot have two HTML5 backends at the same time")
can occur. We can resolve this by ensuring that all uses of react-dnd share the
same context. The platformized lineItem editor uses a specific implementation of this solve
(found in customer-data-ui-utilities), and so we import and use it here as well.

DragDropContext passes ref to a wrapped component
but since functional components do not take ref props, we use a class wrapper
*/
export default SharedDragDropContext()(WithClassWrapper(Profile));
export { Profile };